const APP_NAME = 'Spacebrains'
const DOMAIN = `${APP_NAME.toLowerCase().replace(' ', '')}.tech`

export const CONSTANTS = {
	NAME: APP_NAME,
	APP_NAME_LOWERCASE: APP_NAME.toLowerCase().replace(' ', ''),
	DOMAIN,
	DESCRIPTION: '',

	/** Public-facing names for the two products. */
	RECRUITER_PRODUCT_NAME: `${APP_NAME} for Recruiters`,
	AGENCY_NAME: `${APP_NAME} Recruitment Agency`,

	/**
	 * Canonical production origins. These are the fallbacks used when host
	 * routing is unconfigured (local development, CI, preview deployments);
	 * `app/utils/hosts.server.ts` prefers the configured values.
	 */
	MARKETING_ORIGIN: `https://${DOMAIN}`,
	APP_ORIGIN: `https://app.${DOMAIN}`,
	AGENCY_ORIGIN: `https://agency.${DOMAIN}`,
}

/**
 * Where a signed-in recruiter lands when no explicit destination was requested.
 * `/` is the public homepage, which on the application host only redirects here
 * anyway, so going straight to the dashboard saves a round trip.
 */
export const DASHBOARD_PATH = '/dashboard'
